import {
    EnumDialogName,
    EnumFeature,
    EnumScreenName,
    EnumStepName,
} from '@calm/evexia-analytics';
import { createContext } from 'react';
import { AnalyticsDestination } from '../destination/types';

export interface AnalyticsDialogState {
    onDialogOpen: (dialogName: EnumDialogName) => void;
    onDialogClose: (dialogName: EnumDialogName) => void;
    currentDialog?: EnumDialogName;
}
export interface AnalyticsWizardState {
    step?: EnumStepName;
    setStep: (step?: EnumStepName) => void;
}
export interface AnalyticsState {
    dialog: AnalyticsDialogState;
    wizard: AnalyticsWizardState;
    currentFeature: EnumFeature;
    currentScreenName: EnumScreenName;
}

export interface AnalyticsContextProps {
    destinations: AnalyticsDestination[];
    state: AnalyticsState;
    setCurrentFeature: (feature: EnumFeature) => void;
    setCurrentScreenName: (screenName: EnumScreenName) => void;
}

export const AnalyticsContext = createContext<AnalyticsContextProps>(
    undefined!
);
